import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthService } from './services/auth.service';
import { AppService } from './services/app.service';
 
@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
 
  constructor(
  	public auth: AuthService,
  	private app: AppService
  ) {}
 
  canActivate(): boolean {
    return (this.app.wbMode || this.auth.isAuthenticated());
  }
}
